import { Theme } from '@mui/material';
import { SxProps } from '@mui/system';

const styles = {
  dateBoxGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2,1fr)',
    columnGap: '10px',
  },
  container: {
    backgroundColor: 'common.lightBackgroundColor',

  },
  subContainer: {
    paddingX: '20px',
    paddingY: '24px',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
